import { render, staticRenderFns } from "./InsertOther.vue?vue&type=template&id=02ae883b&"
import script from "./InsertOther.vue?vue&type=script&lang=js&"
export * from "./InsertOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports